'use client';
import config from 'config';
import heic2any from 'heic2any';
import { useState } from 'react';
import { FileUploader } from 'react-drag-drop-files';
import { useDispatch } from 'react-redux';
import gather from 'tools/gather';

export default function Uploader({ setUrl, url }: any) {
  const dispatch = useDispatch<any>();
  const [src, setSrc] = useState(url);

  const handleImageUpload = async (file: any) => {
    if (!file || !file.type.startsWith('image/')) {
      return;
    }
    if (file.type === 'image/heic' || file.type === 'image/heif') {
      try {
        const blob = await heic2any({ blob: file, toType: 'image/jpeg', quality: 0.8 });
        file = new File([blob as Blob], file.name.replace(/\.\w+$/, '.jpg'), { type: 'image/jpeg' });
      } catch (error) {
        return;
      }
    }
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = (e) => {
      const img = new Image();
      img.src = e.target?.result as string;
      img.onload = async () => {
        const canvas = document.createElement('canvas');
        const maxWidth = 1024;
        const maxHeight = 1024;
        let width = img.width;
        let height = img.height;
        if (width > maxWidth || height > maxHeight) {
          const scaleFactor = Math.min(maxWidth / width, maxHeight / height);
          width = Math.floor(width * scaleFactor);
          height = Math.floor(height * scaleFactor);
        }
        canvas.width = width;
        canvas.height = height;
        const ctx = canvas.getContext('2d');
        ctx?.drawImage(img, 0, 0, width, height);
        let quality = 0.8;
        let blob = await new Promise<Blob | null>((resolve) => canvas.toBlob(resolve, 'image/jpeg', quality));
        while (blob && blob.size > 600 * 1024 && quality > 0.2) {
          quality -= 0.1;
          blob = await new Promise<Blob | null>((resolve) => canvas.toBlob(resolve, 'image/jpeg', quality));
        }
        if (blob) {
          setSrc('');
          const formData = new FormData();
          formData.append('type', 'document');
          formData.append('doc', blob);
          const result = await gather(`${config.apiUrl}/v1/admin/file`, true).upload(formData);
          if (result.code === 200) {
            setSrc(config.apiUrl + '/media/' + result.data.link);
            setUrl(config.apiUrl + '/media/' + result.data.link);
          } else {
            alert('ERROR');
          }
        }
      };
    };
  };

  return (
    <div className='uploader'>
      <img src={src} alt='' crossOrigin='anonymous' style={{ width: '100%', height: 100 }} />
      <FileUploader handleChange={handleImageUpload} name='fileImage' types={['JPG', 'PNG', 'JPEG']} />
    </div>
  );
}
